module.exports = __webpack_public_path__ + "static/img/a092.f76190f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a092.jpg
// module id = 6+Y9
// module chunks = 0